<template>
    <div class="card" v-show="value">
        <div class="card-body">
            <h5 class="font-weight-light mb-3">Add New Task</h5>
            <form @submit.prevent="createTask">
                <div class="row">
                    <div class="col-md-12">
                        <input type="text" v-model='title' class="form-control my-2" placeholder="Add your task title">
                        <select v-model="category" class="form-control my-2">
                            <option value="" disabled selected>Select category</option>
                            <option>Backlog</option>
                            <option>Todo</option>
                            <option>Done</option>
                            <option>Complete</option>
                        </select>
                    </div>
                    <div class="col-md-8 mx-auto mt-3">
                        <button class="btn btn-primary btn-block" type="submit">Create</button>
                        <button @click.prevent="close" class="btn btn-danger btn-block">Close</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
export default {
    name: "TaskForm",
    data() {
        return {
            title: "",
            category: "",
            url: 'https://gentle-gorge-36916.herokuapp.com'
        }
    },
    props: {
        value: {
            required: true
        }
    },
    methods: {
        createTask() {
            axios({
                url: `${this.url}/tasks`,
                method: 'post',
                headers: {
                    token: localStorage.token
                },
                data: {
                    title: this.title,
                    category: this.category
                }
            })
            .then(response => {
                this.resetForm()
                swal('Done!','New task created','success')
                this.$emit("input", !this.value);
                this.$emit('reloadTask')
            })
            .catch(err => {
                swal("Error!",err.response.data.message,"error")
                console.log(err)
            })
        },
        resetForm () {
            this.title = ""
            this.category = ""
        },
        close() {
            this.$emit("input", !this.value);
        } 
    }
}
</script>